<template>
    <b-card header="Show Worker Company" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div v-if="!show_company" class="row">
            <div class="col-12">
                <p class="font-weight-bold pt-0 mb-3">Change to show worker company name on timesheets</p>
            </div>

            <div class="col-xl-4 form-group">
                <label class="form-label" for="genius_retention_agreed">Show Company Name</label>
                <p>{{ company.rel_profile.show_worker_company_name === 1 ? 'Yes' : 'No' }}</p>
            </div>

            <div class="col-12">
                <p class="pt-0 mb-3">
                  Enabling this option means that, if a worker's company exists, it will be displayed on the timesheet portal instead of the worker's name and surname.
                </p>
            </div>
            
            <div class="col-12 text-right">
                <button @click="edit_form()" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit</button>
            </div>
        </div>

        <div v-else class="row">
            <ValidationObserver ref="editChargesForm" slim tag="div" class="col-12">
                <div class="col-12">
                    <p class="font-weight-bold pt-0 mb-3">
                      Change to show worker company name on timesheets
                    </p>
                </div>

                <div class="col-xl-6">
                    <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_fee_margin_agreed">
                          Show Company Name
                        </label>
                        <div class="col-xl-4 form-group">
                            <bootstrap-toggle v-model="showCompanyToggle" name="show_company"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <p class="pt-0 mb-3">
                      Enabling this option means that, if a worker's company exists, it will be displayed on the timesheet portal instead of the worker's name and surname.
                    </p>
                </div>

                <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->  
                <div class="row mb-3 mt-2">
                  <div class="col-xl-6">
                    <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
                  </div>
                  <div class="col-xl-6">
                    <button @click="submit_form()" type="submit" class="btn orcaBtn sm_btn w-100">Update</button>
                  </div>
                </div>
            </ValidationObserver>   
        </div>
    </b-card>
</template>

  <script>
  import BootstrapToggle from 'vue-bootstrap-toggle';
  import { getChangedFields } from 'utils/utils';
  export default {
    name: "worker_show_company",
    components: {
      BootstrapToggle
    },
    props: [
      'company'
    ],
    data() {
      return {
        show_company: false,
        edit_show: {},
        original_show: {},
      }
    },
    computed: {
      showCompanyToggle: {
        get() {
          return Boolean(this.edit_show.rel_profile.show_worker_company_name);
        },
        set(newValue) {
          this.edit_show.rel_profile.show_worker_company_name = newValue ? 1 : 0;
        }
      }
    },
    methods: {
        edit_form() {
            this.edit_show = Object.assign({}, this.company);
            this.original_show = Object.assign({}, this.company);
            this.show_company = true;
        },

        cancel_form() {
            this.edit_show = {};
            this.show_company = false;
        },

        submit_form() {
          let charges_promises = [];
          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_show, this.edit_show),
          ];

          charges_promises.push(new Promise(resolve => {
            let submit_ppi = {
              company_id: this.company.id,
              show_worker_company: this.edit_show.rel_profile.show_worker_company_name,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }

            // save updates to database
            axios.patch(this.crmApiPath + 'company/' + this.company.id, submit_ppi).then(() => resolve());
          }));

          
          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
            charges_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'SHOW WORKER COMPANY',
                company_id: this.company.id,
                changes: changed_fields,
              }).then(() => resolve());
            }));
          }


          Promise.all(charges_promises).then(() => {
            this.$bus.$emit('company::reload', {action: true});
            this.show_company = false;  // Hide the edit form after submission
          })
        },

        handleInput() {
          this.edit_show.rel_profile.show_worker_company_name = parseInt(
            this.edit_show.rel_profile.show_worker_company_name
          );
        }
    }
  }
  </script>
